"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from "react";
const COMPONENT_NAME = "QueryParamsProvider";
const QueryParamsContext = createContext(null);
const QueryParamsProvider = ({
  children
}) => {
  const [queryParams, setQueryParams] = useState(
    new URLSearchParams({})
  );
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const updateQueryParams = () => {
        setQueryParams((previousParams) => {
          var _a;
          const currentSearchParams = new URLSearchParams(
            (_a = window.location) == null ? void 0 : _a.search
          );
          const normalizeParams = (searchParams) => decodeURIComponent(searchParams.toString());
          if (normalizeParams(previousParams) === normalizeParams(currentSearchParams)) {
            return previousParams;
          }
          return new URLSearchParams(
            window.location.search
          );
        });
      };
      window.addEventListener("popstate", updateQueryParams);
      updateQueryParams();
      setIsInitialized(true);
      return () => {
        window.removeEventListener("popstate", updateQueryParams);
      };
    }
  }, []);
  return /* @__PURE__ */ jsx(
    QueryParamsContext.Provider,
    {
      value: { isInitialized, queryParams, setQueryParams },
      children
    }
  );
};
const useQueryParams = () => {
  const context = useContext(QueryParamsContext);
  if (!context) {
    throw new Error(
      "useQueryParams must be used within a QueryParamsProvider"
    );
  }
  return context;
};
QueryParamsProvider.displayName = COMPONENT_NAME;
export {
  QueryParamsProvider,
  useQueryParams
};
